import TemplateAvatar from "../components/TemplateAvatar";
import { ImportOutlined } from '@ant-design/icons';
import { GridListDataSource } from "../components/GridList";
import { Avatar } from "antd";

export const AWS_REGIONS = [
    {
        "id": "UsEast2",
        "value": "us-east-2",
        "name": "US East (Ohio)",
    },
    {
        "id": 'UsEast1',
        "value": "us-east-1",
        "name": "US East (N. Virginia)"
    },
    {
        "id": "UsWest1",
        "value": "us-west-1",
        "name": "US West (N. California)"
    },
    {
        "id": "UsWest2",
        "value": "us-west-2",
        "name": "US West (Oregon)"
    },
    {
        "id": "ApEast1",
        "value": "ap-east-1",
        "name": "Asia Pacific (Hong Kong)"
    },
    {
        "id": "ApSouth1",
        "value": "ap-south-1",
        "name": "Asia Pacific (Mumbai)"
    },
    {
        "id": "ApNortheast3",
        "value": "ap-northeast-3",
        "name": "Asia Pacific (Osaka-Local)"
    },
    {
        "id": "ApNortheast2",
        "value": "ap-northeast-2",
        "name": "Asia Pacific (Seoul)"
    },
    {
        "id": "ApSoutheast1",
        "value": "ap-southeast-1",
        "name": "Asia Pacific (Singapore)"
    },
    {
        "id": "ApSoutheast2",
        "value": "ap-southeast-2",
        "name": "Asia Pacific (Sydney)"
    },
    {
        "id": "ApNortheast1",
        "value": "ap-northeast-1",
        "name": "Asia Pacific (Tokyo)"
    },
    {
        "id": "CaCentral1",
        "value": "ca-central-1",
        "name": "Canada (Central)"
    },
    {
        "id": "CnNorth1",
        "value": "cn-north-1",
        "name": "China (Beijing)"
    },
    {
        "id": "CnNorthwest1",
        "value": "cn-northwest-1",
        "name": "China (Ningxia)"
    },
    {
        "id": "EuCentral1",
        "value": "eu-central-1",
        "name": "EU (Frankfurt)"
    },
    {
        "id": "EuWest1",
        "value": "eu-west-1",
        "name": "EU (Ireland)"
    },
    {
        "id": "EuWest2",
        "value": "eu-west-2",
        "name": "EU (London)"
    },
    {
        "id": "EuWest3",
        "value": "eu-west-3",
        "name": "EU (Paris)"
    },
    {
        "id": "EuNorth1",
        "value": "eu-north-1",
        "name": "EU (Stockholm)"
    },
    {
        "id": "MeSouth1",
        "value": "me-south-1",
        "name": "Middle East (Bahrain)"
    },
    {
        "id": "SaEast1",
        "value": "sa-east-1",
        "name": "South America (São Paulo)"
    }
];


export const PRICING_PLANS = [{
    id: "STARTER",
    displayOrder: 1,
    name: "Starter",
    description: "Deploy on your AWS account and own your infrastructure and data.",
    price: "$29",
    trial: "7 days free trial",
    features: [
        "2 Environments",
        "10 Applications",
        "100 Deployments",
        "500 Builds minutes",
        "Custom domains",
        "Integrated CI/CD",
        "Slack integration"
    ]
}, {
    id: "ADVANCED",
    displayOrder: 2,
    name: "Advanced",
    description: "Go live and support your production apps.",
    price: "$99",
    trial: "7 days free trial",
    bordered: true,
    features: [
        "3 Environments",
        "50 Applications",
        "500 Deployments",
        "2000 Builds minutes",
        "Custom domains",
        "Automated rollbacks",
        "Deployment Insights"
    ]
}, {
    id: "CUSTOM",
    displayOrder: 3,
    name: "Custom Business",
    description: "Tailor made plans for your custom infrastructure needs.",
    features: [
        "Custom Environments",
        "Custom Applications",
        "Custom Deployments",
        "Custom Infrastructure Components",
        "Custom Infrastructure Templates",
        "Cloud Waste Manager",
        "Shared Infrastructure",
        "Environment Replication",
        "Multi-Cloud support",
        "Chat support (working hours)",
        "24x7x365 support"
    ]
}];

export const PERMISSIONS = {
    "Owner": "User can do EVERYTHING in the system.",
    "Admin": "User can create components, services, environments, saving schedule, trigger builds and deployments and manage users. User cannot update/delete project.",
    "Write": "User can create components, services, environments, saving schedule, trigger builds and deployments. User cannot manage users in the project.",
    "Read": "User can view everything in the system but will not be allowed to modify anything."
}

export const GIT_TYPES = {
    "github": "GitHub",
    "bitbucket": "Bitbucket",
    "gitlab": "GitLab"
}

export type LOGIN_TYPE = "email" | "github" | "google";

export const EKS_KEY = "eks";

export const TEMPLATES: GridListDataSource[] = [
    {
        key: "import-app",
        title: "Import existing app",
        description: "Import an existing app from your own repository",
        link: "/templates/new?template=https://raw.githubusercontent.com/microtica/templates/master/import-app/template.yaml&import=true",
        avatar: <Avatar size="large" shape="square" style={{ backgroundColor: "var(--layout-body-background)" }} icon={<ImportOutlined style={{ color: "rgba(0, 0, 0, 0.85)" }} />} />,
        pack: "free",
        className: "import-app-grid-item"
    },
    {
        key: "nodejs",
        title: "Node.js (Express)",
        description: "Node.js is an open-source, cross-platform, back-end JavaScript runtime environment that runs on a JavaScript engine.",
        link: "/templates/new?template=https://raw.githubusercontent.com/microtica/templates/master/nodejs/.microtica/template.yaml",
        avatar: <TemplateAvatar size="large" shape="square" name="nodejs" />,
        pack: "free",
        tags: [
            {
                position: "top",
                value: <span style={{ color: "GrayText", fontSize: 12 }}>Free</span>
            }
        ]
    },
    {
        key: "nextjs",
        title: "Next.js",
        description: "Next.js gives you the best developer experience with all the features you need for production.",
        link: "/templates/new?template=https://raw.githubusercontent.com/microtica/templates/master/nextjs/.microtica/template.yaml",
        avatar: <TemplateAvatar size="large" shape="square" name="nextjs" />,
        pack: "free",
        tags: [
            {
                position: "top",
                value: <span style={{ color: "GrayText", fontSize: 12 }}>Free</span>
            }
        ]
    },
    {
        key: "reactjs",
        title: "ReactJS",
        description: "A JavaScript library for building user interfaces.",
        link: "/templates/new?template=https://raw.githubusercontent.com/microtica/templates/master/reactjs/.microtica/template.yaml",
        avatar: <TemplateAvatar size="large" shape="square" name="reactjs" />,
        pack: "free",
        tags: [
            {
                position: "top",
                value: <span style={{ color: "GrayText", fontSize: 12 }}>Free</span>
            }
        ]
    },
    {
        key: "strapi-serverless",
        title: <>Strapi Serverless</>,
        description: "Strapi is the leading open-source headless CMS.",
        link: "/templates/new?template=https://raw.githubusercontent.com/microtica/templates/master/strapi-serverless/.microtica/template.yaml",
        avatar: <TemplateAvatar size="large" shape="square" name="strapi-serverless" />,
        pack: "free",
        tags: [
            {
                position: "top",
                value: <span style={{ color: "GrayText", fontSize: 12 }}>Free</span>
            }
        ]
    },
    {
        key: "medusa-server",
        title: <>Medusa Server</>,
        description: "Medusa is a composable engine that combines an amazing developer experience with endless customizations for merchants to scale.",
        link: "/templates/new?template=https://raw.githubusercontent.com/microtica/templates/master/medusa-server/.microtica/template.yaml",
        avatar: <TemplateAvatar size="large" shape="square" name="medusa" />,
        pack: "free",
        tags: [
            {
                position: "top",
                value: <span style={{ color: "GrayText", fontSize: 12 }}>Free</span>
            }
        ]
    },
    {
        key: "appwrite",
        title: "Appwrite (beta)",
        description: "Secure Open-Source Backend Server for Web, Mobile & Flutter Developers.",
        avatar: <TemplateAvatar size="large" shape="square" name="appwrite" />,
        link: "/templates/new?template=https://raw.githubusercontent.com/microtica/templates/master/appwrite/.microtica/template.yaml",
        pack: "free"
    },
    {
        key: "aws-lambda-golang",
        title: <>Lambda (Golang)</>,
        description: "A Lambda function written in Go language exposed through an API Gateway.",
        link: "/templates/new?template=https://raw.githubusercontent.com/microtica/templates/master/aws-lambda-golang/.microtica/template.yaml",
        avatar: <TemplateAvatar size="large" shape="square" name="lambda" />,
        pack: "free",
        tags: [
            {
                position: "top",
                value: <span style={{ color: "GrayText", fontSize: 12 }}>Free</span>
            }
        ]
    },
    {
        key: "nuxtjs",
        title: "NuxtJS",
        description: "An open source framework for Vue.js making web development simple and powerful.",
        link: "/templates/new?template=https://raw.githubusercontent.com/microtica/templates/master/nuxtjs/.microtica/template.yaml",
        avatar: <TemplateAvatar size="large" shape="square" name="nuxtjs" />,
        pack: "free",
        tags: [
            {
                position: "top",
                value: <span style={{ color: "GrayText", fontSize: 12 }}>Free</span>
            }
        ]
    },
    {
        key: "angular",
        title: "Angular",
        description: "Angular is a framework for developing single page web applications.",
        link: "/templates/new?template=https://raw.githubusercontent.com/microtica/templates/master/angularjs/.microtica/template.yaml",
        avatar: <TemplateAvatar size="large" shape="square" name="angular" />,
        pack: "free",
        tags: [
            {
                position: "top",
                value: <span style={{ color: "GrayText", fontSize: 12 }}>Free</span>
            }
        ]
    },
    {
        key: "vuejs",
        title: "Vue.js",
        description: "An approachable, performant and versatile framework for building web user interfaces.",
        link: "/templates/new?template=https://raw.githubusercontent.com/microtica/templates/master/vuejs/.microtica/template.yaml",
        avatar: <TemplateAvatar size="large" shape="square" name="vuejs" />,
        pack: "free",
        tags: [
            {
                position: "top",
                value: <span style={{ color: "GrayText", fontSize: 12 }}>Free</span>
            }
        ]
    },
    {
        key: "svelte",
        title: "Svelte",
        description: "Svelte is a tool for building fast web applications.",
        link: "/templates/new?template=https://raw.githubusercontent.com/microtica/templates/master/svelte/.microtica/template.yaml",
        avatar: <TemplateAvatar size="large" shape="square" name="svelte" />,
        pack: "free",
        tags: [
            {
                position: "top",
                value: <span style={{ color: "GrayText", fontSize: 12 }}>Free</span>
            }
        ]
    },
    {
        key: "gatsby",
        title: "Gatsby",
        description: "Gatsby enables developers to build fast, secure, and powerful websites using a React-based framework and innovative data layer that makes integrating different content, APIs, and services into one web experience incredibly simple.",
        link: "/templates/new?template=https://raw.githubusercontent.com/microtica/templates/master/gatsby/.microtica/template.yaml",
        avatar: <TemplateAvatar size="large" shape="square" name="gatsby" />,
        pack: "free",
        tags: [
            {
                position: "top",
                value: <span style={{ color: "GrayText", fontSize: 12 }}>Free</span>
            }
        ]
    },
    {
        key: "nestjs",
        title: "NestJS",
        description: "Nest (NestJS) is a framework for building efficient, scalable Node.js server-side applications. It uses progressive JavaScript, is built with and fully supports TypeScript.",
        link: "/templates/new?template=https://raw.githubusercontent.com/microtica/templates/master/nestjs/.microtica/template.yaml",
        avatar: <TemplateAvatar size="large" shape="square" name="nest" />,
        pack: "free",
        tags: [
            {
                position: "top",
                value: <span style={{ color: "GrayText", fontSize: 12 }}>Free</span>
            }
        ]
    },
    {
        key: "gin",
        title: "Gin",
        description: "Gin is a web framework written in Go (Golang). It features a martini-like API with performance that is up to 40 times faster thanks to httprouter.",
        link: "/templates/new?template=https://raw.githubusercontent.com/microtica/templates/master/gin/.microtica/template.yaml",
        avatar: <TemplateAvatar size="large" shape="square" name="gin" />,
        pack: "free",
        tags: [
            {
                position: "top",
                value: <span style={{ color: "GrayText", fontSize: 12 }}>Free</span>
            }
        ]
    },
    {
        key: "n8n",
        title: "n8n.io",
        description: "n8n helps you to interconnect every app with an API.",
        link: "/templates/new?template=https://raw.githubusercontent.com/microtica/templates/master/n8n/.microtica/template.yaml",
        avatar: <TemplateAvatar size="large" shape="square" name="n8n" />,
        pack: "free",
        tags: [
            {
                position: "top",
                value: <span style={{ color: "GrayText", fontSize: 12 }}>Free</span>
            }
        ]
    },
    {
        key: "iris",
        title: "Iris",
        description: "Iris is the fastest HTTP/2 Go Web Framework. Easy to learn. Fast development with Code you control. Unbeatable cost-performance ratio.",
        link: "/templates/new?template=https://raw.githubusercontent.com/microtica/templates/master/iris/.microtica/template.yaml",
        avatar: <TemplateAvatar size="large" shape="square" name="iris" />,
        pack: "free",
        tags: [
            {
                position: "top",
                value: <span style={{ color: "GrayText", fontSize: 12 }}>Free</span>
            }
        ]
    },
    {
        key: "django4",
        title: "Django 4",
        description: "Django is a high-level Python web framework that encourages rapid development and clean, pragmatic design.",
        link: "/templates/new?template=https://raw.githubusercontent.com/microtica/templates/master/django4/.microtica/template.yaml",
        avatar: <TemplateAvatar size="large" shape="square" name="django" />,
        pack: "free",
        tags: [
            {
                position: "top",
                value: <span style={{ color: "GrayText", fontSize: 12 }}>Free</span>
            }
        ]
    },
    {
        key: EKS_KEY,
        title: <>Amazon EKS</>,
        description: "Kubernetes infrastructure based on Amazon EKS.",
        link: "/templates/new?template=https://raw.githubusercontent.com/microtica/templates/master/aws-eks/template.yaml",
        avatar: <TemplateAvatar size="large" shape="square" name="eks" />,
        pack: "free",
        tags: [
            {
                position: "top",
                value: <span style={{ color: "GrayText", fontSize: 12 }}>Free</span>
            }
        ],
        group: "resources",
        repoUrl: "https://github.com/microtica/templates/tree/master/aws-eks"
    },
    {
        key: "fargate",
        title: <>AWS Fargate</>,
        description: "Provides on-demand, right-sized compute capacity for containers.",
        link: "/templates/new?template=https://raw.githubusercontent.com/microtica/templates/master/aws-fargate/.microtica/template.yaml",
        avatar: <TemplateAvatar size="large" shape="square" name="fargate" />,
        pack: "free",
        tags: [
            {
                position: "top",
                value: <span style={{ color: "GrayText", fontSize: 12 }}>Free</span>
            }
        ],
        group: "resources"
    },
    {
        key: "spa",
        title: <>SPA on CloudFront</>,
        description: "An empty ReactJS application hosted on S3 and exposed through Amazon CloudFront on your own domain.",
        link: "/templates/new?template=https://raw.githubusercontent.com/microtica/templates/master/aws-spa-reactjs/.microtica/template.yaml",
        avatar: <TemplateAvatar size="large" shape="square" name="spa" />,
        pack: "free",
        tags: [
            {
                position: "top",
                value: <span style={{ color: "GrayText", fontSize: 12 }}>Free</span>
            }
        ],
        group: "resources"
    },
    {
        key: "eks-spot",
        title: <>Amazon EKS Spot</>,
        description: "Kubernetes infrastructure based on Amazon EKS using Spot instances for Kubernetes nodes.",
        link: "/templates/new?template=https://raw.githubusercontent.com/microtica/templates/master/aws-eks-spot/template.yaml",
        avatar: <TemplateAvatar size="large" shape="square" name="eks-spot" />,
        pack: "free",
        tags: [
            {
                position: "top",
                value: <span style={{ color: "GrayText", fontSize: 12 }}>Free</span>
            }
        ],
        group: "resources"
    },
    {
        key: "webiny",
        title: "Webiny (coming soon)",
        description: "The Enterprise CMS platform that you can host on your cloud.",
        avatar: <TemplateAvatar size="large" shape="square" name="webiny" />,
        link: "/templates/new?template=https://microtica-dev-templates.s3.eu-central-1.amazonaws.com/webiny-serverless.yaml",
        pack: "free",
        disabled: true
    },
    {
        key: "rocketchat",
        title: "Rocket.chat (coming soon)",
        description: "Real-time conversations with your colleagues.",
        avatar: <TemplateAvatar size="large" shape="square" name="rocketchat" />,
        link: "/templates/new?template=rocketchat",
        pack: "free",
        disabled: true
    },
];

export interface IFramework {
    name: string,
    type: "frontend" | "backend",
    buildScript?: string,
    buildDir?: string,
    port?: string,
    dockerfilePort: string
};
export const FRAMEWORKS: IFramework[] = [
    {
        name: "NodeJS",
        buildScript: "build",
        buildDir: "dist",
        port: "3000",
        type: "backend",
        dockerfilePort: "3000"
    },
    {
        name: "NextJS",
        buildScript: "build",
        buildDir: ".next",
        port: "3000",
        type: "backend",
        dockerfilePort: "3000"
    },
    {
        name: "NuxtJS",
        buildScript: "build",
        buildDir: ".nuxt",
        port: "3000",
        type: "backend",
        dockerfilePort: "3000"
    },
    {
        name: "ReactJS",
        buildScript: "build",
        buildDir: "build",
        port: "8000",
        type: "frontend",
        dockerfilePort: "80"
    },
    {
        name: "Angular",
        buildScript: "build",
        buildDir: "dst",
        port: "4200",
        type: "frontend",
        dockerfilePort: "80"
    },
    {
        name: "VueJS",
        buildScript: "build",
        buildDir: "dist",
        port: "8080",
        type: "frontend",
        dockerfilePort: "80"
    },
    {
        name: "Svelte",
        buildScript: "build",
        buildDir: "dist",
        port: "4173",
        type: "frontend",
        dockerfilePort: "80"
    },
    {
        name: "Gin",
        port: "8080",
        type: "backend",
        dockerfilePort: "8080"
    },
    {
        name: "Iris",
        port: "8080",
        type: "backend",
        dockerfilePort: "8080"
    },
    {
        name: "Gatsby",
        buildScript: "build",
        buildDir: "public",
        port: "9000",
        type: "backend",
        dockerfilePort: "9000"
    },
    {
        name: "NestJS",
        buildScript: "build",
        buildDir: "dist",
        port: "3000",
        type: "backend",
        dockerfilePort: "3000"
    },
    {
        name: "Strapi",
        port: "1337",
        type: "backend",
        dockerfilePort: "1337"
    },
    {
        name: "Python",
        port: "8000",
        type: "backend",
        dockerfilePort: "8000"
    },
    {
        name: "Django",
        port: "8000",
        type: "backend",
        dockerfilePort: "8000"
    },
    {
        name: "Other",
        buildScript: "build",
        buildDir: "dist",
        port: "8080",
        type: "backend",
        dockerfilePort: "80"
    }
];
